export var PromotionTagEnum;
(function (PromotionTagEnum) {
    PromotionTagEnum["DEALS_PAGE"] = "DEALS_PAGE";
    PromotionTagEnum["CORPORATE_ENTITY"] = "CORPORATE_ENTITY";
    PromotionTagEnum["FRANCHISE_ENTITY"] = "FRANCHISE_ENTITY";
    PromotionTagEnum["CAPABILITY_POS_AUTO_APPLICABLE"] = "CAPABILITY:POS_AUTO_APPLICABLE";
    PromotionTagEnum["CAPABILITY_POS_AUTO_APPLICABLE_BLOCKED"] = "CAPABILITY:POS_AUTO_APPLICABLE_BLOCKED";
    PromotionTagEnum["VIRTUAL_DISCOUNT_LEVEL_COMBO"] = "VIRTUAL_DISCOUNT_LEVEL_COMBO";
    PromotionTagEnum["DISCOUNT_RULE_QUANTITY_MIN"] = "DISCOUNT_RULE:QUANTITY_MIN";
    PromotionTagEnum["DISCOUNT_RULE_QUANTITY_EXACT"] = "DISCOUNT_RULE:QUANTITY_EXACT";
    PromotionTagEnum["DISCOUNT_RULE_BUY_ONE_GET_ONE"] = "DISCOUNT_RULE:BUY_ONE_GET_ONE";
})(PromotionTagEnum || (PromotionTagEnum = {}));
//# sourceMappingURL=PromotionTagEnum.js.map